import basicVisibleVue from './basicVisible.vue';
export default {
  components: {
    basicVisibleVue: basicVisibleVue
  }
};